import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthAndACLService } from '../auth_and_acl/authAndACL.service';
import { URL_API } from '../constante';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private authAndACL: AuthAndACLService) { }

  ngOnInit() {
    this.login();
  }

  login(): void {
    this.authAndACL.login();
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts